module.exports = __webpack_public_path__ + "static/media/smartdrive_logo.727a75c5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/smartdrive_logo.svg
// module id = 888
// module chunks = 0